var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgList({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.615 0A3.385 3.385 0 0124 3.385v12.307a3.385 3.385 0 01-3.385 3.385l-1.539-.001v1.715a3.208 3.208 0 01-3.026 3.204l-.182.005H4.615a4.616 4.616 0 01-4.61-4.404L0 19.385V8.132a3.21 3.21 0 013.027-3.204l.182-.005h1.714V3.385A3.385 3.385 0 018.308 0h12.307zM4.923 6.769H3.209c-.709 0-1.29.54-1.357 1.232l-.006.13v11.254a2.77 2.77 0 002.6 2.764l.17.005h11.252c.708 0 1.29-.54 1.357-1.232l.006-.13-.001-1.716H8.308a3.385 3.385 0 01-3.385-3.384V6.77zm15.692-4.923H8.308c-.85 0-1.539.689-1.539 1.539v12.307c0 .85.689 1.539 1.539 1.539h12.307c.85 0 1.539-.689 1.539-1.539V3.385c0-.85-.689-1.539-1.539-1.539zm-3.077 9.23a.923.923 0 01.108 1.84l-.108.007h-6.153a.923.923 0 01-.108-1.84l.108-.006h6.153zm0-4.922a.923.923 0 110 1.846h-6.153a.923.923 0 010-1.846z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.6c7454dd.svg";
export { ForwardRef as ReactComponent };